export default __webpack_public_path__ + "s11.png";